export default __webpack_public_path__ + "static/media/attack.e6533fe3.svg";